import { type FC } from 'react';

import { useSubscriptionPlan } from 'hooks/Subscriptions';
import { useGrowthABExperimentsState } from 'hooks/useAssignGrowthABGroups';
import { HighlightProvider } from 'hooks/useHighlight';
import { ABTest } from 'types/growthExperiments.types';
import type {
  NavbarItemType,
  NavbarNavigationListType,
} from 'types/navbar.types';
import { isWeb } from 'utils/constants';
import { isSubscriptionTrialPlan } from 'utils/subscriptions.utils';
import AccountMenu from './AccountMenu.component';
import MoreMenu from './MoreMenu';
import NavigationItem from './NavigationItem.component';
import SupportMenu from './SupportMenu';
import TrialFeaturesList from './TrialFeaturesList.component';

const Sidebar: FC<{
  navigationList: NavbarNavigationListType;
  sidebarRef?: any;
  sidebarTop?: number;
}> = ({ navigationList = [], sidebarRef, sidebarTop }) => {
  const { experiments } = useGrowthABExperimentsState();

  const allowedItems = navigationList.filter(
    ({ condition = true }) => !!condition,
  );

  const plan = useSubscriptionPlan();

  const isInTrial = isSubscriptionTrialPlan(plan?.planInternalName);

  return (
    <HighlightProvider className="animate-highlightTaxes">
      <div
        className="bottom-0 fixed z-50 bg-transparent md:w-[var(--sidebar-width)] invisible md:visible"
        style={{ top: sidebarTop }}
        ref={sidebarRef}
      >
        <div className="bg-primary-25 border-r border-r-[#E7E7E7] h-full flex flex-col justify-between py-6 px-4 flex-grow">
          <div className="flex h-full items-center gap-2 justify-start flex-col overflow-y-auto">
            {isWeb &&
            isInTrial &&
            experiments.PRO_FEATURES_NUDGE_IN_TRIAL === ABTest.B ? (
              <TrialFeaturesList />
            ) : null}
            {allowedItems
              .filter(({ placement }) => placement !== 'bottom')
              .map(
                ({ Component, ...item }: NavbarItemType) =>
                  Component || <NavigationItem key={item.title} item={item} />,
              )}
          </div>

          <div className="flex items-center gap-2 justify-start flex-col">
            {allowedItems
              .filter(({ placement }) => placement === 'bottom')
              .map(
                ({ Component, ...item }: NavbarItemType) =>
                  Component || <NavigationItem key={item.title} item={item} />,
              )}

            <SupportMenu />

            <MoreMenu />

            <AccountMenu />
          </div>
        </div>
      </div>
    </HighlightProvider>
  );
};

export default Sidebar;
